import React from "react";
import styled from "styled-components";
import owner from "../assets/img/owner.jpg"
export default function AboutUs() {
    return (
        <Wrapper>
            <ContentWrapper>
                <Header>
                    <Title>Gleitwort</Title>
                    <OwnerImage src={owner} alt="Hossein Zadeh" />
                </Header>
                <Paragraph>
                    <strong>Ein Stück Orient mitten in Böblingen.</strong>
                </Paragraph>
                <Paragraph>
                    Der Zauber des Morgenlandes. Die Farbe der Wüste.
                    Des Himmels, exotischer Blüten und vielfältiger
                    Pflanzen. Die Muster von Ranken, Bäumen und Ornamenten.
                    Die faszinierende Fertigkeit der Knüpfkunst.
                </Paragraph>
                <Paragraph>
                    Das alles finden Sie in der besonderen Atmosphäre im Hause
                    Hosseinzadeh. Im Zentrum von Böblingen bietet sich Ihnen eine schöne
                    Auswahl an ausgesuchten klassischen Teppichen, Nomaden-Teppichen
                    und pflanzlich-gefärbten Teppichen. Hier verbinden sich 35 Jahre
                    Berufserfahrung mit der Begeisterung für das Metier.
                </Paragraph>
                <Paragraph>
                    Das Ergebnis unserer Anstrengungen sind äußerst interessante und aus-
                    gefallene Teppiche, die sowohl aufgrund ihrer Gestaltung als auch durch
                    die verwendeten Materialien überzeugen. Handgesponnene Wolle und
                    altbewährte Pflanzenfarben bewahren auch weiterhin die kulturelle
                    Tradition vor Ort.
                </Paragraph>
                <Paragraph>
                    Durch diese Bemühungen hoffen wir, die Wertschätzung der Iranischen
                    Teppiche zu neuem Leben erweckt und auch für zukünftige Generatio-
                    nen erhalten zu haben.
                </Paragraph>
                <Signature>
                    Ismaeil Hosseinzadeh<br />Inhaber und Teppichgutachter
                </Signature>
            </ContentWrapper>
        </Wrapper>
    );
}

const Wrapper = styled.section`
  padding-top: 70px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ContentWrapper = styled.div`
  width: 100%;
  max-width: 800px;
  background-color: #f3f3f3;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1px;
`;

const Title = styled.h1`
  font-size: 28px;
  font-weight: bold;
`;

const OwnerImage = styled.img`
  width: 180px;
  height: 200px;
  border-radius: 10%;
  object-fit: cover;
`;

const Paragraph = styled.p`
  font-size: 16px;
  margin-bottom: 15px;
`;

const Signature = styled.p`
  margin-top: 15px;
  text-align: right;
  font-weight: bold;
`;